import { ReceiveCartFooter } from './ReceiveCartFooter';
import { ReceiveCartItems } from './ReceiveCartItems';
import { ReceiveCartItemsHeader } from './ReceiveCartItemsHeader';
import type { CartAmazonDeal, CartGetItem } from 'src/types';

type Props = {
  cartItems: CartGetItem[];
  cartVendor: string;
  cartTotalPrice: string;
  cartCCY: string;
  cartCCYS: string;
  cartTimestamp: number;
  cartStore: string;
  cartLocale?: string;
  dealForItem?: (item: CartGetItem) => CartAmazonDeal | null;
};

export const ReceiveBody = ({
  cartItems,
  cartVendor,
  cartTotalPrice,
  cartCCY,
  cartCCYS,
  cartTimestamp,
  cartStore,
  cartLocale,
  dealForItem,
}: Props) => {
  return (
    <div style={{ minHeight: window.innerHeight - 300 }}>
      <ReceiveCartItemsHeader
        cartItems={cartItems}
        cartVendor={cartVendor}
        cartTimestamp={cartTimestamp}
        cartStore={cartStore}
      />
      <ReceiveCartItems
        cartItems={cartItems}
        cartVendor={cartVendor}
        cartTimestamp={cartTimestamp}
        cartCCY={cartCCY}
        cartCCYS={cartCCYS}
        cartLocale={cartLocale}
        dealForItem={dealForItem}
      />
      <ReceiveCartFooter cartTotalPrice={cartTotalPrice} />
    </div>
  );
};
